<div class="filter-indicator">
  <span>{{label}} </span>
  @if(count){
    <span>({{count}})</span>
  }
</div>
